import { FILES_URL } from "../Config";
import { Purpose } from "../domain/enums/purpose-enum";
import { IBaseModel } from "../domain/models/BaseModel";
import { IFile } from "../domain/models/File";

export class BaseModelImpl<T> implements IBaseModel<T> {
    files?: IFile[];
    private coverPath?: string;

    assignData(data?: T) {
        if (!data) {
            return;
        }
        Object.assign(this, data);
    }

    pictureExists(purposeType: Purpose = Purpose.COVER): boolean {
        if (!this.files) return false;

        this.coverPath = this.files.find(
            (file) => file.purposeType === purposeType
        )?.filePath;

        return !!this.coverPath;
    }

    getPictureUrl(): string | null {
        if (!this.coverPath) return null;
        return `${FILES_URL}/${this.coverPath}`;
    }
}
